import React from 'react';

const ShareIcon = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M16.6107 7.57687L10.9857 1.95187C10.9267 1.89294 10.8516 1.85282 10.7698 1.83658C10.688 1.82033 10.6032 1.82868 10.5262 1.86058C10.4492 1.89248 10.3833 1.9465 10.3369 2.01581C10.2906 2.08512 10.2658 2.16661 10.2657 2.25V5.21718C6.4351 5.4696 1.8008 9.08437 1.27064 13.7011C1.25343 13.8481 1.28304 13.9968 1.35526 14.126C1.42749 14.2552 1.53864 14.3583 1.67289 14.4206C1.80714 14.4829 1.95763 14.5013 2.10293 14.4731C2.24824 14.4449 2.38094 14.3716 2.48213 14.2636C3.27385 13.4191 6.11728 10.7297 10.2657 10.556V13.5C10.2658 13.5834 10.2906 13.6649 10.3369 13.7342C10.3833 13.8035 10.4492 13.8575 10.5262 13.8894C10.6032 13.9213 10.688 13.9297 10.7698 13.9134C10.8516 13.8972 10.9267 13.857 10.9857 13.7981L16.6107 8.17312C16.6897 8.09402 16.7341 7.98679 16.7341 7.875C16.7341 7.7632 16.6897 7.65597 16.6107 7.57687ZM11.1095 12.4819V10.125C11.1095 10.0131 11.065 9.9058 10.9859 9.82668C10.9068 9.74757 10.7995 9.70312 10.6876 9.70312C8.73783 9.70312 6.83728 10.2129 5.0401 11.2184C3.9926 11.8068 3.02771 12.5315 2.17064 13.3734C2.50111 11.5059 3.58814 9.71718 5.26439 8.29195C6.92377 6.8864 8.95018 6.04687 10.6876 6.04687C10.7995 6.04687 10.9068 6.00242 10.9859 5.92331C11.065 5.84419 11.1095 5.73688 11.1095 5.625V3.26882L15.7156 7.875L11.1095 12.4819Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ShareIcon;
